<div class="z-tabs" role="tablist" aria-label="Pestañas de la sección">

  @for (tab of tabs; track tab.id; let i = $index) {
    <button #tabButton
            class="tab"
            type="button"
            role="tab"
            [id]="'z-tab-' + tab.id"
            [class.active]="isActive(tab)"
            [attr.aria-selected]="isActive(tab)"
            [attr.tabindex]="tabIndexFor(tab, i)"
            (click)="select(tab)"
            (keydown)="onKeydown($event, i)">

      @if (tab.icon) {
        <i class="bi {{ tab.icon }}" aria-hidden="true"></i>
      }

      <span>{{ tab.label }}</span>

      @if (tab.count !== undefined && tab.count !== null) {
        <span class="z-tab-count tab-count">{{ tab.count }}<span class="z-sr-only"> registros</span></span>
      }
    </button>
  }

</div>
